<template>
  <v-card flat color="transparent">
    <v-card-text class="py-0">
      <v-row class="ma-0 pa-0" align="center" style="height: 60px;">
        <v-col cols="12" class="pa-0 b-B">
          <v-toolbar flat color="transparent" height="40">
            <v-toolbar-title class="text-left subheading">
              <span class="title">生徒</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <template v-if="func == 1">
              <v-btn depressed rounded small color="error" dark @click="dataExport()" type="submit">出力</v-btn>
            </template>
            <template v-else-if="func == 2">
              <v-btn depressed rounded small color="error" @click.stop="removeDialog = true">削除</v-btn>
            </template>
          </v-toolbar>
        </v-col>
      </v-row>
      <v-sheet class="overflow-y-auto" color="transparent" :style="Height + ' scroll-behavior: smooth;'">
        <v-row class="ma-0 pa-0" align="start" justify="center">
          <v-col cols="12" class="px-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0"></v-col>
              <v-col cols="4" class="pa-0">
                <v-select
                  :items='functions'
                  label='機能'
                  v-model='func'
                  item-text="name"
                  item-value="key"
                  small-chips
                  outlined
                  hideDetails
                ></v-select>
              </v-col>
               <v-col cols="3" class="py-0">
                <v-select
                  v-if="func == 0 || func == 1 || (func == 3 && !modified)"
                  :items='inputFormats'
                  label='形式'
                  v-model='row'
                  item-text="name"
                  item-value="key"
                  small-chips
                  outlined
                  hideDetails
                ></v-select>
               </v-col>
              <v-col cols="4" class="pa-0" align="end">
                <template v-if="func == 0 || func == 3">
                  <input @change="select" @click="fileReset" type="file" name="file" :accept="row != 'json' ? 'text/csv' : 'application/json'" ref="file">
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <v-chip v-if="!modified" @click="onFile()" small color="primary"><span>{{ fileName ? fileName : '選択してください' }}</span></v-chip>
                      <v-btn v-if="file != null && !modified" depressed fab x-small @click="onReset()" class="mx-2" color="transparent"><v-icon >mdi-close</v-icon></v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <v-btn v-if="file != null || (file == null && modified && group != 'none')" depressed rounded small color="error" dark @click="func == 0 ? checkUpload() : storeDialog = true" type="submit">{{ func == 0 ? '取込み' : '保存' }}</v-btn>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0"></v-col>
              <v-col cols="4" class="pa-0">
                <v-select
                  ref="group"
                  :items='myGroups'
                  label='教室'
                  v-model='group'
                  item-text="name"
                  item-value="key"
                  small-chips
                  outlined
                  :clearable="func != 0"
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="3" class="py-0">
                <v-select
                  v-if="func == 3 || func == 4"
                  :items="$YEARS"
                  label="年度"
                  v-model.number="year"
                  item-text="name"
                  item-value="value"
                  small-chips
                  outlined
                  :rules="[rules.required]"
                ></v-select>
                <v-select
                  ref="agent"
                  v-else-if="func == 0 && data.root"
                  :items="agents"
                  label="担当"
                  v-model="agent"
                  item-text="name"
                  item-value="key"
                  small-chips
                  outlined
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="4" class="py-0"></v-col>
            </v-row>
          </v-col>
          <template v-if="func < 3">
            <v-col cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0" align="center"></v-col>
                <v-col cols="11" class="pa-0">
                  <v-row class="ma-0 py-0" align="center">
                    <v-col cols="12" class="py-0 b-B-GREY-DARK" align="center">
                      <v-row align="center" justify="center" style="height:48px;">
                        <template v-for="(header, index) in headers">
                          <v-col :cols="header.width" :align="header.align" class="pa-0" :key="header.key">
                            <v-sheet class="pa-0 customHeader" color="transparent">
                              <template v-if="header.key == 'number'">
                                <v-row class="ma-0 pa-0" align="center">
                                  <v-col cols="3" class="pa-0">
                                    <span>#</span>
                                  </v-col>
                                  <v-col cols="9" class="pa-0">
                                    <v-checkbox
                                      v-model="all"
                                      color="primary"
                                      @change="onChangeSelectedAll()"
                                      dense
                                      hide-details
                                      class="ma-0 pa-0"
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>
                              </template>
                              <template v-else-if="header.valid">
                                <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                                <v-icon :color="headers[index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                              </template>
                              <template v-else>
                                <span>{{ header.title }}</span>
                              </template>
                            </v-sheet>
                          </v-col>
                        </template>
                        <v-col class="pa-0" align="center">
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="pa-0" align="center">
                      <div class='overflow-y-auto'>
                        <RecycleScroller
                          class="scroller"
                          :items="func == 1 || func == 2 ? myStoredStudents : myLoadedStudents"
                          :item-size="44"
                          key-field="key"
                        >
                          <template v-slot="{ item, index }">
                            <v-sheet :color="'transparent'" height="44" class="b-B-GREY">
                              <v-row class="ma-0 pa-0 customLine" align="center" style="height: 44px;">
                                <template v-for="(header) in headers">
                                  <v-col :cols="header.width" class="pa-0" align="start" :key="header.key">
                                    <template v-if="header.key == 'number'">
                                      <v-row class="ma-0 pa-0" align="center">
                                        <v-col cols="3" class="pa-0">
                                          <span class="overflow-text-hidden">{{ index + 1 }}</span>
                                        </v-col>
                                        <v-col cols="9" class="pa-0">
                                          <v-checkbox
                                            v-model="selected[item.key]"
                                            color="primary"
                                            @change="onChangeSelected(item)"
                                            dense
                                            hide-details
                                            class="ma-0 pa-0"
                                            :disabled="checkDisable(item)"
                                          ></v-checkbox>
                                        </v-col>
                                      </v-row>
                                    </template>
                                    <template v-else-if="header.key == 'enableType'">
                                      <v-chip x-small :color="item.enable ? 'primary' : 'error'"><span >{{ item.enable ? '有効' : '無効' }}</span></v-chip>
                                    </template>
                                    <template v-else-if="header.key == 'gradeNumber'">
                                      <span class="overflow-text-hidden"  @click="student = item, studentDialog = true">{{ getGradeName(item[header.key]) }}</span>
                                    </template>
                                    <template v-else>
                                      <span class="overflow-text-hidden"  @click="student = item, studentDialog = true">{{ item[header.key] }}</span>
                                    </template>
                                  </v-col>
                                </template>
                              </v-row>
                            </v-sheet>
                          </template>
                        </RecycleScroller>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </template>
          <template v-else>
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0" align="center"></v-col>
              <v-col cols="11" class="pa-0">
                <v-col cols="12" class="pa-0 b-B">
                  <v-toolbar flat color="transparent" height="40">
                    <v-toolbar-title class="text-left subheading">
                      <span class="title"></span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </v-col>
                <v-card-text>
                  <v-row align="center" class="ma-0 pa-0">
                    <v-col cols="12" class="pt-0 px-0" align="end">
                      <v-btn depressed rounded small color="primary" @click.stop="onInit()">初期化</v-btn>
                    </v-col>
                    <v-col cols="2" class="pa-0">
                      <v-toolbar flat height="21" color="transparent" >
                        <v-spacer></v-spacer>
                      </v-toolbar>
                    </v-col>
                    <v-col cols="10" class="pa-0">
                      <v-row align="center" class="ma-0 pa-0">
                        <v-col class="pa-0" align="center" v-for="i in 12" :key="i">
                          <v-sheet
                            :color="getWeekColor(1)"
                            dark
                            height="21"
                            :key="i"
                            tile
                            :class="i == 12 ? 'b-L-GREY b-R-GREY b-T-GREY text-center' : 'b-L-GREY b-T-GREY text-center'"
                          >
                            <span :class="'primary' + '--text font-weight-bold'">{{ getMonth(i) }}</span>
                          </v-sheet>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="2" class="pa-0">
                      <v-toolbar flat height="24" color="transparent" class="b-L-GREY b-T-GREY text-center">
                        <v-spacer></v-spacer>
                        <span class="primary--text span">[適用]</span>
                      </v-toolbar>
                    </v-col>
                    <v-col cols="10" class="pa-0">
                      <v-row align="center" class="ma-0 pa-0">
                        <v-col align="center" class="pa-0 ma-0" v-for="i in 12" :key="i">
                          <v-sheet
                            :color="getWeekColor(1)"
                            dark
                            height="24"
                            :key="i"
                            tile
                            :class="i == 12 ? 'b-L-GREY b-R-GREY b-T-GREY text-center' : 'b-L-GREY b-T-GREY text-center'"
                          >
                            <input type="checkbox" v-model="checked[i-1]" @change="onChecked()">
                          </v-sheet>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <template v-for="(metric, index) in revisesHeaders">
                    <v-row align="center" class="ma-0 pa-0" :key="index">
                      <v-col cols="2" class="pa-0">
                        <v-sheet color="transparent" tile :class="(revisesHeaders.length - 1) == index ? 'b-L-GREY b-T-GREY b-B-GREY' : 'b-L-GREY b-T-GREY'" height="21">
                          <template v-if="metric.type != 'header'">
                            <span :class="metric.type == 'none' ? 'pl-4 white--text' : 'pl-4'">{{ metric.name }}</span>
                          </template>
                          <template v-else>
                            <v-toolbar flat color="primary" height="20">
                              <span class="white--text">{{ metric.name }}</span>
                              <v-spacer></v-spacer>
                            </v-toolbar>
                          </template>
                        </v-sheet>
                      </v-col>
                      <v-col cols="10" class="pa-0">
                        <v-row align="center" class="ma-0 pa-0">
                          <v-col class="pa-0" v-for="i in 12" :key="i">
                            <v-sheet
                              :class="getBackgroundColor (0, i, index)"
                              :color="metric.type == 'header' ? getWeekColor(1) : 'transparent'"
                              height="21"
                              :key="i"
                              tile
                            >
                              <template v-if="i != 13">
                                <input
                                  type="number"
                                  :class="metric.type == 'header' ? 'primary--text' : ''"
                                  style="text-align: right; width: 100%;"
                                  :disabled="metric.type == 'header' && metric.key != 0"
                                  v-model.number="values[i - 1][index]"
                                  @change="onChange($event, i - 1, index)"
                                />
                              </template>
                              <template v-else>
                                <span
                                  style="text-align: right; width: 100%;"
                                  :class="metric.type == 'header' ? 'pr-1 primary--text font-weight-bold' : 'pr-1 font-weight-bold'"
                                >
                                  {{ values[i - 1][index] }}
                                </span>
                              </template>
                            </v-sheet>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </template>
                </v-card-text>
                <template v-if="group != 'none'">
                  <v-col cols="12" class="pa-0 b-B">
                    <v-toolbar flat color="transparent" height="40">
                      <v-toolbar-title class="text-left subheading">
                        <span class="title"></span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-col>
                  <v-row class="ma-0 py-0" align="center">
                    <v-col cols="12" class="py-0 b-B-GREY-DARK" align="center">
                      <v-row align="center" justify="center" style="height:48px;">
                        <template v-for="(header, index) in revisesTableHeaders">
                          <v-col :cols="header.width" :align="header.align" class="pa-0" :key="header.key">
                            <v-sheet class="pa-0 customHeader" color="transparent">
                              <template v-if="header.key == 'number'">
                                <v-row class="ma-0 pa-0" align="center">
                                  <v-col cols="3" class="pa-0">
                                    <span>#</span>
                                  </v-col>
                                </v-row>
                              </template>
                              <template v-else-if="header.valid">
                                <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                                <v-icon :color="headers[index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                              </template>
                              <template v-else>
                                <span>{{ header.title }}</span>
                              </template>
                            </v-sheet>
                          </v-col>
                        </template>
                        <v-col class="pa-0" align="center">
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="pa-0" align="center">
                      <div class='overflow-y-auto'>
                        <RecycleScroller
                          class="scroller"
                          :items="revises"
                          :item-size="44"
                          key-field="key"
                        >
                          <template v-slot="{ item, index }">
                            <v-sheet :color="'transparent'" height="44" class="b-B-GREY">
                              <v-row class="ma-0 pa-0 customLine" align="center" style="height: 44px;">
                                <template v-for="(header) in revisesTableHeaders">
                                  <v-col :cols="header.width" class="pa-0" align="start" @click.stop="onSelect(item)" :key="header.key">
                                    <template v-if="header.key == 'number'">
                                      <v-row class="ma-0 pa-0" align="center">
                                        <v-col cols="3" class="pa-0">
                                          <span class="overflow-text-hidden">{{ index + 1 }}</span>
                                        </v-col>
                                      </v-row>
                                    </template>
                                    <template v-else-if="header.key == 'delete'">
                                      <v-btn icon @click.stop="revice = item, removeDialog = true">
                                        <v-icon color="error">mdi-delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <template v-else-if="header.key == 'updatedAt'">
                                        <span>{{ item[header.key] | moment }}</span>
                                    </template>
                                    <template v-else>
                                      <span class="overflow-text-hidden">{{ item[header.key] }}</span>
                                    </template>
                                  </v-col>
                                </template>
                              </v-row>
                            </v-sheet>
                          </template>
                        </RecycleScroller>
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
            </v-row>
          </template>
        </v-row>
      </v-sheet>
    </v-card-text>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='取込み'
        message='データを取込みます。よろしいですか?'
        :dialog='dialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='保存'
        message='データを保存します。よろしいですか?'
        :dialog='storeDialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='削除'
        message='データを削除します。よろしいですか?'
        :dialog='removeDialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <v-dialog v-model="studentDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-student-dialog
          v-if="studentDialog"
          @dismissed="onDismissed"
          :dialog='studentDialog'
          :item="student"
          type="view"
        >
        </app-student-dialog>
      </v-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-card>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import encoding from 'encoding-japanese'
import * as async from 'async'
import * as Papa from 'papaparse'
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      students: 'students/students',
      rheaders: 'metricsRevises/headers',
      preHeader: 'metricsRevises/preHeader',
      preHeader_extension_1: 'metricsRevises/preHeader_extension_1',
      metricsRevises: 'metricsRevises/metrics',
      windowSize: 'shared/windowSize',
      preschool: 'shared/preschool',
      extension: 'shared/extension'
    }),
    myStoredStudents () {
      var temp = []
      for (var i in this.students) {
        if (!this.admin && !this.students[i].enable) {
          continue
        }
        if (this.group === 'none') {
          var keys = Object.keys(this.students[i].groups)
          var check = false
          for (var x in keys) {
            if (this.students[i].groups[keys[x]]) {
              check = true
            }
          }
          if (!check && this.students[i].schools[this.school.key]) {
            temp.push(this.getViewData(JSON.parse(JSON.stringify(this.students[i]))))
          }
        } else if (this.students[i].groups[this.group]) {
          temp.push(this.getViewData(JSON.parse(JSON.stringify(this.students[i]))))
        }
      }
      var key = null
      for (i in this.headers) {
        if (this.headers[i].value) {
          key = this.headers[i].key
          if (this.headers[i].value === 1) {
            temp.sort(function (a, b) {
              if (a[key] > b[key]) return -1
              if (a[key] < b[key]) return 1
              return 0
            })
          } else {
            temp.sort(function (a, b) {
              if (a[key] < b[key]) return -1
              if (a[key] > b[key]) return 1
              return 0
            })
          }
          break
        }
      }
      return temp
    },
    myLoadedStudents () {
      var temp = []
      for (var i in this.myStudents) {
        temp.push(this.getViewData(JSON.parse(JSON.stringify(this.myStudents[i]))))
      }
      return temp
    },
    myGroups () {
      var temp = []
      if (!this.data.root) {
        if (this.data.order) {
          for (var i in this.data.order) {
            var index = this.groups.findIndex(group => group.key === this.data.order[i])
            if (index !== -1) {
              if (this.groups[index].enable && this.groups[index].classroom) {
                var payload = JSON.parse(JSON.stringify(this.groups[i]))
                payload.classType = payload.classroom ? '教室' : 'グループ'
                payload.publicType = payload.public ? '公開' : '非公開'
                payload.enableType = payload.enable ? '有効' : '無効'
                temp.push(this.groups[index])
              }
            }
          }
        } else {
          var keys = Object.keys(this.data.groups)
          for (i in keys) {
            if (this.data.groups[keys[i]]) {
              index = this.groups.findIndex(g => g.key === keys[i])
              if (index !== -1) {
                if (this.groups[index].enable && this.groups[index].classroom) {
                  payload = JSON.parse(JSON.stringify(this.groups[index]))
                  payload.classType = payload.classroom ? '教室' : 'グループ'
                  payload.publicType = payload.public ? '公開' : '非公開'
                  payload.enableType = payload.enable ? '有効' : '無効'
                  temp.push(payload)
                }
              }
            }
          }
        }
      } else {
        keys = Object.keys(this.school.groups)
        for (i in keys) {
          if (this.school.groups[keys[i]]) {
            index = this.groups.findIndex(g => g.key === keys[i])
            if (index !== -1) {
              if (this.groups[index].enable && this.groups[index].classroom) {
                payload = JSON.parse(JSON.stringify(this.groups[index]))
                payload.classType = payload.classroom ? '教室' : 'グループ'
                payload.publicType = payload.public ? '公開' : '非公開'
                payload.enableType = payload.enable ? '有効' : '無効'
                temp.push(payload)
              }
            }
          }
        }
      }
      return temp
    },
    mySchool () {
      if (this.school) {
        return JSON.parse(JSON.stringify(this.school))
      } else {
        var keys = Object.keys(this.data.schools)
        for (var i in keys) {
          if (this.data.schools[keys[i]]) {
            var index = this.schools.findIndex(s => s.key === keys[i])
            if (index !== -1) {
              return JSON.parse(JSON.stringify(this.schools[index]))
            }
          }
        }
      }
      return null
    },
    functions () {
      if (this.getPrivilegesLevel(this.data) > 1) {
        return [
          { key: 0, name: '生徒データ取込' },
          { key: 1, name: '生徒データ出力' }
        ]
      } else {
        return [
          { key: 0, name: '生徒データ取込' },
          { key: 1, name: '生徒データ出力' },
          { key: 2, name: '生徒削除' },
          { key: 3, name: '実績数値取込・保存' },
          { key: 4, name: '実績数値削除' }
        ]
      }
    },
    inputFormats () {
      if (this.func === 0) {
        if (this.getPrivilegesLevel(this.data) === 0) {
          return [
            { key: 'exGrow', name: 'ExGrow' },
            { key: 'comiru', name: 'Comiru' },
            { key: 'csv', name: 'CSV' },
            { key: 'json', name: 'JSON' }
          ]
        } else {
          return [
            { key: 'exGrow', name: 'ExGrow' },
            { key: 'comiru', name: 'Comiru' },
            { key: 'csv', name: 'CSV' }
          ]
        }
      } else {
        if (this.getPrivilegesLevel(this.data) === 0) {
          return [
            { key: 'csv', name: 'CSV' },
            { key: 'json', name: 'JSON' }
          ]
        } else {
          return [
            { key: 'csv', name: 'CSV' }
          ]
        }
      }
    },
    revises () {
      var temp = []
      for (var i in this.metricsRevises) {
        if (this.metricsRevises[i].groups[this.group] && this.metricsRevises[i].year === this.year) {
          temp.push(JSON.parse(JSON.stringify(this.metricsRevises[i])))
        }
      }
      return temp
    },
    Height () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 40) + 'px;'
    }
  },
  data () {
    return {
      dialog: false,
      studentDialog: false,
      removeDialog: false,
      storeDialog: false,
      year: this.getFY(),
      modified: false,
      selected: {},
      myStudents: [],
      all: false,
      group: 'none',
      func: 0,
      format: 'csv',
      row: 'csv',
      fileName: null,
      file: null,
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ],
      headers: [
        { valid: false, over: false, value: 2, title: '#', key: 'number', width: '2', align: 'start' },
        { valid: true, over: false, value: 2, title: '名前', key: 'name', width: '5', align: 'start' },
        { valid: true, over: false, value: 2, title: '学年', key: 'gradeNumber', width: '2', align: 'start' },
        { valid: true, over: false, value: 0, title: '生年月日', key: 'birth', width: '2', align: 'start' },
        { valid: false, over: false, value: 0, title: '状態', key: 'enableType', width: '1', align: 'start' }
      ],
      revisesTableHeaders: [
        { valid: false, over: false, value: 2, title: '#', key: 'number', width: '1', align: 'start' },
        { valid: true, over: false, value: 2, title: '年', key: 'year', width: '8', align: 'start' },
        { valid: false, over: false, value: 0, title: '更新日', key: 'updatedAt', width: '2', align: 'start' },
        { valid: false, over: false, value: 2, title: '', key: 'delete', width: '1', align: 'end' }
      ],
      values: null,
      checked: null,
      loading: false,
      url: null,
      revice: null,
      student: null,
      agent: null,
      agents: [],
      rules: {
        required: value => !!value || '必須'
      },
      revisesHeaders: []
    }
  },
  watch: {
    func () {
      if (this.func === 0) {
        this.onReset()
      } else if (this.func === 1 || this.func === 2) {
        this.createStudents()
      } else {
        this.onReset()
      }
    },
    group () {
      this.createStudents()
      if (this.func === 3) {
        this.onInit()
      }
    },
    year () {
      if (this.func === 3) {
        this.onInit()
      }
    },
    students () {
      if (this.func === 0) {
        return
      }
      this.createStudents()
    }
  },
  props: [ 'type', 'school', 'admin', 'contentsHeight' ],
  created () {
    this.createHeaders()
    this.onValueInit()
  },
  mounted () {
    this.createStudents()
  },
  methods: {
    createHeaders () {
      this.revisesHeaders = JSON.parse(JSON.stringify(this.rheaders))
      if (this.preschool) {
        if (this.extension === 1) {
          this.revisesHeaders = JSON.parse(JSON.stringify(this.preHeader_extension_1))
        } else {
          this.revisesHeaders.splice(1, 0, this.preHeader)
        }
      }
    },
    createStudents () {
      this.selected = {}
      this.all = false
      for (var i in this.myStoredStudents) {
        if (!this.admin && !this.myStoredStudents[i].enable) {
          continue
        }
        if (this.group === 'none') {
          var keys = Object.keys(this.myStoredStudents[i].groups)
          var check = false
          for (var x in keys) {
            if (this.myStoredStudents[i].groups[keys[x]]) {
              check = true
            }
          }
          if (!check) {
            this.selected[this.myStoredStudents[i].key] = true
          }
        } else if (this.myStoredStudents[i].groups[this.group]) {
          this.selected[this.myStoredStudents[i].key] = true
        }
      }

      if (Object.keys(this.selected).length !== 0) {
        this.all = true
      }
    },
    onInit () {
      this.onValueInit()
      this.readRevises()
    },
    onValueInit () {
      var vm = this
      this.modified = false
      this.values = [
        [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
        [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
        [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
        [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
        [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
        [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
        [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
        [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
        [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
        [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
        [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
        [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ]
      ]
      this.checked = [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
      ]
      this.revice = null
      if (this.data.root) {
        this.agents = []
        var temp = this.users.filter(function (item, index) {
          return item.schools[vm.school.key]
          // if (item.schools[vm.school.key] && item.role === 'owner') {
          //   return vm.data.key !== item.key
          // }
        })
        this.agents = temp
      }
    },
    readRevises () {
      var count = this.preschool ? (this.extension === 1 ? 22 : 18) : 17
      if (this.revises.length !== 0) {
        for (var i = 0; i < 12; i++) {
          var data = this.revises[0][i]
          if (data.enable) {
            for (var x = 0; x < count; x++) {
              if (typeof data[this.revisesHeaders[x].key] !== 'undefined') {
                this.values[i][x] = data[this.revisesHeaders[x].key].value
              } else {
                this.values[i][x] = 0
              }
            }
            this.checked[i] = true
          }
        }
        this.revice = this.revises[0]
      }
    },
    getBackgroundColor (mm, i, index) {
      var color = (i === 12 ? 'd-flex b-L-GREY b-R-GREY b-T-GREY' : 'd-flex b-L-GREY b-T-GREY')
      if ((this.revisesHeaders.length - 1) === index) {
        color += ' b-B-GREY'
      }
      return color
    },
    checkDisable (item) {
      if (this.getGrade(item) === null) {
        return true
      }
      if (item.seiY === null && item.meiY === null && item.sei === null && item.mei === null) {
        return true
      }
      return false
    },
    checkValue (item, i, index, metric) {
      return true
    },
    getValue (mm, index, metric) {
      return this.values[mm - 1][index]
    },
    checkGroup (metric) {
      return true
    },
    checkUpload () {
      if (this.data.root) {
        console.log(this.$refs.agent.validate(true), this.$refs.group.validate(true))
        if (this.$refs.agent.validate(true) && this.$refs.group.validate(true)) {
          this.dialog = true
        }
      } else {
        this.dialog = true
      }
    },
    isValidDate (d) {
      return moment(d).isValid()
    },
    getViewData (payload) {
      payload['gradeNumber'] = this.getGrade(payload)
      return payload
    },
    gerPrivileges (user) {
      var index = this.$PRIVILEGES.findIndex(p => p.role === user.role)
      if (index !== -1) {
        return this.$PRIVILEGES[index].name
      }
      return ''
    },
    getProfileImage (item) {
      if (item.avatar) {
        return item.avatar.thumbnail
      }
      return ''
    },
    onSelect (item) {
      this.revice = JSON.parse(JSON.stringify(item))
    },
    getSortIcon (item) {
      return this.sortIcons[this.headers[item].value]
    },
    onChange ($event, mm, index) {
      var offset = 0
      if (this.preschool) {
        if (this.extension !== 1) {
          offset = 1
        } else {
          offset = 5
        }
      }
      if (this.values[mm][index] === '') {
        Vue.set(this.values[mm], index, 0)
      }
      this.modified = true

      var v = 0
      if (this.preschool && this.extension === 1) {
        for (var i = 0; i < 4; i++) {
          v += this.values[mm][i + 2]
        }
        Vue.set(this.values[mm], 1, v)
      }

      v = 0
      for (i = 0; i < 6; i++) {
        v += this.values[mm][i + 2 + offset]
      }
      Vue.set(this.values[mm], 1 + offset, v)

      v = 0
      for (i = 0; i < 3; i++) {
        v += this.values[mm][i + 9 + offset]
      }
      Vue.set(this.values[mm], 8 + offset, v)

      v = 0
      for (i = 0; i < 4; i++) {
        v += this.values[mm][i + 13 + offset]
      }
      Vue.set(this.values[mm], 12 + offset, v)
      if (this.preschool) {
        if (this.extension !== 1) {
          Vue.set(this.values[mm], 0, this.values[mm][1] + this.values[mm][2] + this.values[mm][9] + this.values[mm][13])
        } else {
          Vue.set(this.values[mm], 0, this.values[mm][1] + this.values[mm][6] + this.values[mm][13] + this.values[mm][17])
        }
      } else {
        Vue.set(this.values[mm], 0, this.values[mm][1] + this.values[mm][8] + this.values[mm][12])
      }
    },
    calcTotal () {
      var offset = 0
      if (this.preschool) {
        if (this.extension !== 1) {
          offset = 1
        } else {
          offset = 5
        }
      }
      for (var x = 0; x < 12; x++) {
        var v = 0
        if (this.preschool && this.extension === 1) {
          for (var i = 0; i < 4; i++) {
            v += this.values[x][i + 2]
          }
          Vue.set(this.values[x], 1, v)
        }

        for (i = 0; i < 6; i++) {
          v += this.values[x][i + 2 + offset]
        }
        Vue.set(this.values[x], 1 + offset, v)

        v = 0
        for (i = 0; i < 3; i++) {
          v += this.values[x][i + 9 + offset]
        }
        Vue.set(this.values[x], 8 + offset, v)

        v = 0
        for (i = 0; i < 4; i++) {
          v += this.values[x][i + 13 + offset]
        }
        Vue.set(this.values[x], 12 + offset, v)

        if (this.preschool) {
          if (this.extension !== 1) {
            Vue.set(this.values[x], 0, this.values[x][1] + this.values[x][2] + this.values[x][9] + this.values[x][13])
          } else {
            Vue.set(this.values[x], 0, this.values[x][1] + this.values[x][6] + this.values[x][13] + this.values[x][17])
          }
        } else {
          Vue.set(this.values[x], 0, this.values[x][1] + this.values[x][8] + this.values[x][12])
        }
        Vue.set(this.values[x], 0, this.values[x][1] + this.values[x][8] + this.values[x][12])
      }

      for (var y = 0; y < 17; y++) {
        var h = 0
        for (i = 0; i < 12; i++) {
          h += this.values[i][y]
        }
        Vue.set(this.values[12], y, h)
      }
    },
    onChangeSelectedAll () {
      var keys = Object.keys(this.selected)
      var temp = {}
      for (var i in keys) {
        if (this.func === 0 && this.checkDisable(this.myStudents[i])) {
          temp[keys[i]] = false
        } else {
          temp[keys[i]] = this.all
        }
      }
      this.selected = temp
    },
    onChangeSelected (item) {
    },
    onMouse (item, value) {
      this.headers[item].over = value
    },
    onSort (item) {
      var temp = this.headers[item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in this.headers) {
        this.headers[i].value = 0
      }
      this.headers[item].value = temp
    },
    onDismissed: function (value) {
      if (this.studentDialog) {
        this.studentDialog = false
        return
      }
      if (this.storeDialog) {
        this.storeDialog = false
        if (value) {
          this.onStore()
        }
        return
      }
      if (this.dialog) {
        this.dialog = false
        if (value) {
          this.onUpload()
        }
        return
      }
      if (this.removeDialog) {
        this.removeDialog = false
        if (value) {
          if (this.func === 3 || this.func === 4) {
            this.onRemoveRevices()
          } else {
            this.onRemove()
          }
        }
        return
      }
      this.dialog = false
    },
    onFile () {
      this.$refs.file.click()
    },
    onReset () {
      if (this.file) {
        this.file = null
        this.fileName = null
      }
      this.modified = false
      this.row = 'csv'
      this.selected = {}
      this.all = false
      this.myStudents = []
      if (this.func === 3) {
        this.onInit()
      }
    },
    exGrow (element) {
      var vm = this
      return new Promise((resolve) => {
        if (typeof element['生徒名漢字（苗字）'] === 'undefined') {
          resolve()
          return
        }
        var payload = JSON.parse(JSON.stringify(vm.$store.getters['students/initial']))
        var m = null
        payload.imported = true
        if (element.入学日) {
          m = moment(element.入学日)
        } else {
          m = moment(new Date().toString())
        }
        moment.tz.setDefault('Asia/Tokyo')
        payload.admission = m.isValid() ? m.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        payload.status = this.$STATUS_ADMISSION
        payload.name = element['生徒名漢字（苗字）'] + element['生徒名漢字（名前）']
        payload.sei = element['生徒名漢字（苗字）']
        payload.mei = element['生徒名漢字（名前）']
        payload.seiY = element['生徒名かな（苗字）']
        payload.meiY = element['生徒名かな（名前）']
        payload.grade = null
        m = moment(element.生年月日)
        moment.tz.setDefault('Asia/Tokyo')
        payload.birth = m.isValid() ? m.format('YYYY-MM-DD') : null
        var contact = JSON.parse(JSON.stringify(vm.$store.getters['students/contact']))
        var address = (element['住所（市区町村・番地）'].replace(/[A-Za-z0-9]/g, ' ').replace(/-/g, ' ').split(' '))[0]
        contact.id = 1
        contact.type = 1
        contact.zip = element.郵便番号
        contact.address = address
        contact.address2 = element['住所（市区町村・番地）'].replace(address, '')
        contact.phone = element.電話番号
        contact.mobile = element['生徒携帯番号']
        contact.email2 = element['生徒携帯メール']
        payload.contacts.push(contact)
        contact = JSON.parse(JSON.stringify(vm.$store.getters['students/contact']))
        contact.id = 2
        contact.type = 2
        contact.sei = element['生徒名漢字（苗字）']
        contact.seiY = element['生徒名かな（苗字）']
        contact.phone = element.電話番号
        contact.mobile = element['保護者携帯番号1']
        contact.email = element['保護者パソコンメール1']
        contact.email2 = element['保護者携帯メール1']
        contact.zip = null
        contact.address = null
        contact.address2 = null
        payload.contacts.push(contact)
        payload.key = 'key_' + vm.myStudents.length
        vm.selected[payload.key] = false
        vm.myStudents.push(payload)
        resolve()
      })
    },
    comiru (element) {
      var vm = this
      return new Promise((resolve) => {
        if (typeof element.名前 === 'undefined') {
          resolve()
          return
        }
        var payload = JSON.parse(JSON.stringify(vm.$store.getters['students/initial']))
        moment.tz.setDefault('Asia/Tokyo')
        payload.admission = moment().format('YYYY-MM-DD')
        payload.status = this.$STATUS_ADMISSION
        payload.imported = true
        payload.name = element.名前
        payload.sei = element.名前
        payload.grade = null
        var m = moment(element.生年月日)
        if (m.isValid()) {
          moment.tz.setDefault('Asia/Tokyo')
          payload.birth = m.format('YYYY-MM-DD')
        }
        var contact = JSON.parse(JSON.stringify(vm.$store.getters['students/contact']))
        var address = (element.住所.replace(/[A-Za-z0-9]/g, ' ').replace(/-/g, ' ').split(' '))[0]
        contact.id = 1
        contact.type = 1
        contact.address = address
        contact.address2 = element.住所.replace(address, '')
        vm.$store.dispatch('postcode/search', address).then(function (data) {
          if (data) {
            contact.zip = data.val().a0
          }
          payload.contacts.push(contact)
          contact = JSON.parse(JSON.stringify(vm.$store.getters['students/contact']))
          contact.id = 2
          contact.type = 2
          contact.phone = element.電話番号
          contact.email = element.メールアドレス
          payload.contacts.push(contact)
          payload.key = 'key_' + vm.myStudents.length
          vm.selected[payload.key] = false
          vm.myStudents.push(payload)
          resolve()
        })
      })
    },
    csv (element) {
      var vm = this
      return new Promise((resolve) => {
        if (typeof element.sei === 'undefined') {
          resolve()
          return
        }
        var payload = JSON.parse(JSON.stringify(vm.$store.getters['students/initial']))
        payload.imported = true
        moment.tz.setDefault('Asia/Tokyo')
        var d = this.isValidDate(element.admission) ? moment(element.admission).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        payload.admission = d
        payload.status = this.$STATUS_ADMISSION
        payload.sei = element.sei ? element.sei : null
        payload.mei = element.mei ? element.mei : null
        payload.name = (payload.sei ? payload.sei : '') + ' ' + (payload.mei ? payload.mei : '')
        payload.seiY = element.seiY ? element.seiY : null
        payload.meiY = element.meiY ? element.meiY : null
        payload.grade = this.checkGrade(element.grade)
        d = this.isValidDate(element.birth) ? moment(element.birth).format('YYYY-MM-DD') : null
        payload.birth = d
        payload.gender = this.checkGender(element.gender)

        for (var suffix = 1; suffix < 3; suffix++) {
          if (element['id_' + String(suffix)]) {
            var contact = JSON.parse(JSON.stringify(vm.$store.getters['students/contact']))
            contact.id = suffix
            contact.type = element['type_' + String(suffix)]
            contact.sei = element['sei_' + String(suffix)]
            contact.seiY = element['seiY_' + String(suffix)]
            contact.mei = element['mei_' + String(suffix)]
            contact.meiY = element['meiY_' + String(suffix)]
            contact.gender = element['gender_' + String(suffix)]
            contact.zip = element['zip_' + String(suffix)]
            contact.address = element['address_' + String(suffix)]
            contact.address2 = element['address2_' + String(suffix)]
            contact.email = element['email_' + String(suffix)]
            contact.email2 = element['email2_' + String(suffix)]
            contact.mobile = element['mobile_' + String(suffix)]
            contact.phone = element['phone_' + String(suffix)]
            payload.contacts.push(contact)
          }
        }
        payload.key = 'key_' + vm.myStudents.length
        vm.selected[payload.key] = false
        vm.myStudents.push(payload)
        resolve()
      })
    },
    checkGrade (grade) {
      var temp = parseInt(grade)
      if (temp >= 0 && temp <= 13) {
        return temp
      }
      return null
    },
    checkGender (gender) {
      var temp = parseInt(gender)
      if (temp >= 1 && temp <= 4) {
        return temp
      }
      return null
    },
    valueRead (element) {
      var vm = this
      return new Promise((resolve) => {
        if (typeof element.yyyy === 'undefined') {
          resolve()
          return
        }
        var index = Number(element.item)
        var yyyy = Number(element.yyyy)
        var mm = Number(element.mm) >= 4 ? Number(element.mm) - 4 : Number(element.mm) + 8
        var value = Number(element.value)
        Vue.set(vm.values[mm], index - 1, value)
        vm.year = yyyy
        resolve()
      })
    },
    fileRead (e) {
      var vm = this
      this.all = false
      e.preventDefault()
      let files = e.target.files
      this.file = files[0]
      this.fileName = this.file.name
      var reader = new FileReader()
      reader.onerror = function () {
        console.log('error')
      }
      this.myStudents = []
      this.selected = {}
      this.onValueInit()
      reader.onload = function () {
        var enc = encoding.detect(Buffer.from(reader.result))
        if (enc === 'UNICODE' || enc === 'SJIS') {
          enc = 'Shift-JIS'
        }
        if (vm.row === 'json') {
          vm.myStudents = JSON.parse(reader.result)
          for (var x in vm.myStudents) {
            vm.selected[vm.myStudents[x].key] = false
          }
          vm.loading = false
        } else {
          Papa.parse(files[0], {
            encoding: enc,
            header: true,
            complete: function (results) {
              async.eachSeries(results.data, function (element, cb) {
                if (vm.func === 0) {
                  if (vm.row === 'comiru') {
                    vm.comiru(element).then(() => {
                      cb()
                    })
                  } else if (vm.row === 'exGrow') {
                    vm.exGrow(element).then(() => {
                      cb()
                    })
                  } else {
                    vm.csv(element).then(() => {
                      cb()
                    })
                  }
                } else {
                  vm.valueRead(element).then(() => {
                    cb()
                  })
                }
              }, function (error) {
                if (error) {
                  console.log(error)
                }
                if (vm.func === 3) {
                  vm.calcTotal()
                }
                vm.loading = false
              })
            },
            error () {
              vm.loading = false
            }
          })
        }
      }
      if (vm.row === 'json') {
        reader.readAsText(vm.file)
      } else {
        reader.readAsArrayBuffer(vm.file)
      }
    },
    async select (e) {
      this.loading = true
      const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      await pause(500).then(() => {
        this.fileRead(e)
      })
    },
    fileReset (e) {
      e.target.value = ''
    },
    onChecked () {
      var value = false
      for (var i in this.checked) {
        if (this.checked[i]) {
          value = true
        }
      }
      this.modified = value
    },
    onUpload () {
      var vm = this
      this.dialog = false
      var payload = null
      this.$nextTick(function () {
        if (this.func === 0) {
          var temp = JSON.parse(JSON.stringify(this.selected))
          var keys = Object.keys(temp)
          async.eachSeries(JSON.parse(JSON.stringify(keys)), function (key, cb) {
            if (temp[key]) {
              vm.loading = true
              var index = vm.myStudents.findIndex(s => s.key === key)
              if (index !== -1) {
                payload = JSON.parse(JSON.stringify(vm.myStudents[index]))
                payload.key = null
                if (vm.row !== 'json') {
                  if (vm.group !== 'none') {
                    payload.groups[vm.group] = true
                  } else {
                    payload.groups = {}
                  }
                  payload.schools[vm.mySchool.key] = true
                  payload['createdAt'] = parseInt(new Date().getTime())
                  payload['updatedAt'] = parseInt(new Date().getTime())
                  if (vm.data.root) {
                    payload.charge = vm.agent
                  } else {
                    payload.charge = vm.user.uid
                  }
                  var event = JSON.parse(JSON.stringify(vm.$store.getters['students/event']))
                  event.date1 = payload.admission
                  if (vm.data.root) {
                    event.charge = vm.agent
                  } else {
                    event.charge = vm.user.uid
                  }
                  event.status = 5
                  event.id = 1
                  event.createdAt = event.updatedAt = parseInt(new Date().getTime())
                  payload.events.unshift(event)
                  vm.$store.dispatch('students/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
                    const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
                    pause(200).then(() => {
                      cb()
                    })
                  })
                } else {
                  var schools = {}
                  schools[vm.school.key] = true
                  payload.schools = schools
                  var groups = {}
                  groups[vm.group] = true
                  payload.groups = groups
                  payload.charge = vm.agent
                  payload.imported = false
                  for (var i in payload.events) {
                    payload.events[i]['charge'] = vm.agent
                  }
                  vm.$store.dispatch('students/copy', JSON.parse(JSON.stringify(payload))).then((resp) => {
                    if (resp) {
                      payload.key = resp
                      const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
                      pause(100).then(() => {
                        for (var i in payload.events) {
                          payload.events[i].counter = payload.events[i].counter + 1
                        }
                        vm.$store.dispatch('students/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
                          cb()
                        })
                      })
                    } else {
                      cb()
                    }
                  })
                }
              } else {
                cb()
              }
            } else {
              cb()
            }
          }, function (error) {
            if (error) {
              console.log(error)
            }
            vm.onReset()
            vm.loading = false
          })
        } else {
        }
      })
    },
    onStore () {
      var vm = this
      var temp = {}
      var count = this.preschool ? (this.extension === 1 ? 22 : 18) : 17
      this.loading = true
      for (var m = 0; m < 12; m++) {
        var payload = {}
        for (var x = 0; x < count; x++) {
          if (this.checked[m]) {
            payload[this.revisesHeaders[x].key] = { value: this.values[m][x] }
          } else {
            payload[this.revisesHeaders[x].key] = { value: 0 }
          }
        }
        temp[m] = payload
        temp[m]['enable'] = this.checked[m]
      }
      if (this.revice) {
        payload = JSON.parse(JSON.stringify(this.revice))
      } else {
        payload = JSON.parse(JSON.stringify(this.$store.getters['metricsRevises/initial']))
      }
      payload.year = vm.year
      payload.author = vm.data.key
      for (x = 0; x < 12; x++) {
        payload[x] = temp[x]
      }
      payload.groups[vm.group] = true
      payload.schools[this.mySchool.key] = true
      if (payload.key) {
        payload.updatedAt = parseInt(new Date().getTime())
      } else {
        payload.createdAt = payload.updatedAt = parseInt(new Date().getTime())
      }
      vm.$store.dispatch('metricsRevises/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
        vm.readRevises()
        vm.loading = false
      })
    },
    dataExport () {
      var aTag = null
      var blob = null
      var name = '未所属'
      if (this.group !== 'none') {
        var index = this.groups.findIndex(g => g.key === this.group)
        if (index !== -1) {
          name = this.groups[index].name
        }
      }
      if (this.row === 'csv') {
        var temp = []
        const config = {
          delimiter: ',', // 区切り文字
          header: true, // キーをヘッダーとして扱う
          newline: '\n' // 改行
        }
        var keys = Object.keys(this.selected)
        for (var x in keys) {
          if (this.selected[keys[x]]) {
            index = this.students.findIndex(s => s.key === keys[x])
            if (index !== -1) {
              var v = this.students[index]
              var payload = {
                sei: v.sei ? v.sei : null,
                seiY: v.seiY ? v.seiY : null,
                mei: v.mei ? v.mei : null,
                meiY: v.meiY ? v.meiY : null,
                birth: v.birth ? v.birth : null,
                gender: v.gender ? v.gender : null,
                grade: v.grade ? v.grade : null,
                admission: v.admission ? v.admission : null,
                graduation: v.graduation ? v.graduation : null,
                secession: v.secession ? v.secession : null,
                status: v.status ? v.status : null,
                charge: v.charge ? v.charge : null,

                id_1: v.contacts[0] ? v.contacts[0].id : null,
                type_1: v.contacts[0] ? v.contacts[0].type : null,
                sei_1: v.contacts[0] ? v.contacts[0].sei : null,
                seiY_1: v.contacts[0] ? v.contacts[0].seiY : null,
                mei_1: v.contacts[0] ? v.contacts[0].mei : null,
                meiY_1: v.contacts[0] ? v.contacts[0].meiY : null,
                gender_1: v.contacts[0] ? v.contacts[0].gender : null,
                zip_1: v.contacts[0] ? v.contacts[0].zip : null,
                address_1: v.contacts[0] ? v.contacts[0].address : null,
                address2_1: v.contacts[0] ? v.contacts[0].address2 : null,
                email_1: v.contacts[0] ? v.contacts[0].email : null,
                email2_1: v.contacts[0] ? v.contacts[0].email2 : null,
                mobile_1: v.contacts[0] ? v.contacts[0].mobile : null,
                phone_1: v.contacts[0] ? v.contacts[0].phone : null,

                id_2: v.contacts[1] ? v.contacts[1].id : null,
                type_2: v.contacts[1] ? v.contacts[1].type : null,
                sei_2: v.contacts[1] ? v.contacts[1].sei : null,
                seiY_2: v.contacts[1] ? v.contacts[1].seiY : null,
                mei_2: v.contacts[1] ? v.contacts[1].mei : null,
                meiY_2: v.contacts[1] ? v.contacts[1].meiY : null,
                gender_2: v.contacts[1] ? v.contacts[1].gender : null,
                zip_2: v.contacts[1] ? v.contacts[1].zip : null,
                address_2: v.contacts[1] ? v.contacts[1].address : null,
                address2_2: v.contacts[1] ? v.contacts[1].address2 : null,
                email_2: v.contacts[1] ? v.contacts[1].email : null,
                email2_2: v.contacts[1] ? v.contacts[1].email2 : null,
                mobile_2: v.contacts[1] ? v.contacts[1].mobile : null,
                phone_2: v.contacts[1] ? v.contacts[1].phone : null,

                id_3: v.contacts[2] ? v.contacts[2].id : null,
                type_3: v.contacts[2] ? v.contacts[2].type : null,
                sei_3: v.contacts[2] ? v.contacts[2].sei : null,
                seiY_3: v.contacts[2] ? v.contacts[2].seiY : null,
                mei_3: v.contacts[2] ? v.contacts[2].mei : null,
                meiY_3: v.contacts[2] ? v.contacts[2].meiY : null,
                gender_3: v.contacts[2] ? v.contacts[2].gender : null,
                zip_3: v.contacts[2] ? v.contacts[2].zip : null,
                address_3: v.contacts[2] ? v.contacts[2].address : null,
                address2_3: v.contacts[2] ? v.contacts[2].address2 : null,
                email_3: v.contacts[2] ? v.contacts[2].email : null,
                email2_3: v.contacts[2] ? v.contacts[2].email2 : null,
                mobile_3: v.contacts[2] ? v.contacts[2].mobile : null,
                phone_3: v.contacts[2] ? v.contacts[2].phone : null
              }
              temp.push(payload)
            }
          }
        }
        const delimiterString = Papa.unparse(temp, config)
        blob = new Blob([delimiterString], { type: 'text/csv' })
        aTag = document.createElement('a')
        aTag.download = moment().format('YYYY-MM-DD') + '-' + name + '.csv'
      } else {
        var data = []
        keys = Object.keys(this.selected)
        for (x in keys) {
          if (this.selected[keys[x]]) {
            index = this.students.findIndex(s => s.key === keys[x])
            if (index !== -1) {
              data.push(JSON.stringify(this.students[index]))
            }
          }
        }
        blob = new Blob(['[' + data + ']'], { type: 'text/plain' })
        aTag = document.createElement('a')
        aTag.download = moment().format('YYYY-MM-DD') + '-' + name + '.json'
      }
      if (window.navigator.msSaveBlob) {
        // for IE
        window.navigator.msSaveBlob(blob, aTag.download)
      } else if (window.URL && window.URL.createObjectURL) {
        // for Firefox
        aTag.href = window.URL.createObjectURL(blob)
        document.body.appendChild(aTag)
        aTag.click()
        document.body.removeChild(aTag)
      } else if (window.webkitURL && window.webkitURL.createObject) {
        // for Chrome
        aTag.href = (window.URL || window.webkitURL).createObjectURL(blob)
        aTag.click()
      } else {
        // for Safari
        window.open(
          `data:type/csv;base64,${window.Base64.encode(this.state.content)}`,
          '_blank'
        )
      }
    },
    onRemoveRevices () {
      var vm = this
      if (this.revice) {
        vm.loading = true
        vm.$store.dispatch('metricsRevises/delete', JSON.parse(JSON.stringify(this.revice.key))).then((resp) => {
          vm.onValueInit()
          vm.loading = false
        })
      }
    },
    onRemove () {
      this.removeDialog = false
      var vm = this
      this.loading = true
      this.$nextTick(function () {
        var temp = JSON.parse(JSON.stringify(this.selected))
        var keys = Object.keys(temp)
        async.eachSeries(JSON.parse(JSON.stringify(keys)), function (key, cb) {
          if (temp[key]) {
            if (vm.data.root) {
              vm.$store.dispatch('students/delete', JSON.parse(JSON.stringify(key))).then(() => {
                const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
                pause(200).then(() => {
                  cb()
                })
              })
            } else {
              vm.$store.dispatch('students/disable', JSON.parse(JSON.stringify(key))).then(() => {
                const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
                pause(200).then(() => {
                  cb()
                })
              })
            }
          } else {
            cb()
          }
        }, function (error) {
          if (error) {
            console.log(error)
          }
          vm.loading = false
        })
      })
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>

<style scoped>
img {
  object-fit: cover !important;
}
.scroller {
  height: 100%;
}

input[type="file"]:focus {
  outline: 0 !important;
}

input[type="file"] {
  display: none;
}

.overflow-text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  user-select: none !important;
}

.b-B-GREY {
  border-bottom: 1px solid #EEEEEE80 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B-GREY-DARK {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.customHeader {
  cursor: pointer;
  line-height: 48px;
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}

.b-R-GREY {
  border-right: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-L-GREY {
  border-left: 1px solid #80808080 !important;
  border-left-width: 1px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-T-GREY {
  border-top: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-B-GREY {
  border-bottom: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
